"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function omit(obj, fields) {
  var shallowCopy = (0, _extends3["default"])({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

exports["default"] = omit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/omit.js/lib/index.js
// module id = 31
// module chunks = 0 1